import { useEffect } from "react";
import { sandboxApi } from "services/sandbox-api/api";
import { TrackedSandboxEvent, useTrackSandboxEvent } from "services/telemetry-service/telemetry";
import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionCompleted, sandboxActionInvoked, sandboxLikedStateChanged, selectCurrentUser } from "store/features";

interface LikeSandboxActionHandlerProps {
  sandboxId?: string;
  userId?: string;
}

export const LikeSandboxActionHandler = ({ sandboxId, userId }: LikeSandboxActionHandlerProps) => {
  const user = useAppSelector(selectCurrentUser);
  const sandboxUser = useAppSelector((state) => state.auth.sandboxUser);
  const dispatch = useAppDispatch();
  const trackEvent = useTrackSandboxEvent<TrackedSandboxEvent>("Sandbox liked");

  useEffect(() => {
    if (!user) {
      dispatch(sandboxActionInvoked({ type: "signin-prompt", args: { actionResumeType: "like" } }));
      return;
    }

    if (!sandboxUser) {
      dispatch(sandboxActionInvoked({ type: "set-username", args: { actionResumeType: "like" } }));
      return;
    }

    if (sandboxId && userId) {
      dispatch(sandboxApi.endpoints.codeShareLike.initiate({ id: sandboxId, userId })).unwrap()
        .then((response) => {
          if (response.isLiked)
            trackEvent({ SandboxName: response.name, SandboxUser: response.username, SandboxUserId: response.userId, SandboxId: response.id });

          dispatch(sandboxLikedStateChanged(response));
          dispatch(sandboxActionCompleted());
        });
    }
  });

  return null;
};